export enum Feature {
  TestMarketingSsrSetup = "test-marketing-ssr-setup",
  AddInstagramReelsToReviewsSlider = "instagram-reels-reviews-section",
  AddStoreSliderToHomepage = "add-store-slider-to-the-homepage",
}
